import { CardHeader, Grid, Paper } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { FID_LOGO } from "../DrawerAppBar";
import { useNavigate } from "react-router-dom";
import AuthService from "../../../service/AuthService";
import useToast from "../../../hooks/useToast";
import { useQuery } from "../../../hooks/useQuery";
import useNotification from "../../../hooks/useNotification";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";

const CompteActivationPage = () => {
  const { Toast, showToast } = useToast();
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const { NotificationComponent, showNotification } = useNotification();
  const navigate = useNavigate();
  const url = useQuery();

  const handleCheckToken = () => {
    setloading(true);
    const authData = {
      uuid: url.get("ref"),
      token: url.get("token"),
    };
    if (
      Object.values(authData).some((value) => value === "" || value === null)
    ) {
      showNotification(
        "Information incomplete",
        "Veuillez utiliser le lien foruni via l'email",
        TYPE_NOTIFICATION.ERROR,
        () => {
          navigate("/login");
        },
        "Continuer avec la page d'authentification"
      );
      setloading(false);
      return;
    }
    AuthService.activateAccount(authData)
      .then((res) => {
        if (res && res.success) {
          showNotification(
            "Compte activé avec succès",
            res.message,
            TYPE_NOTIFICATION.SUCCESS,
            () => {
              navigate("/login");
            },
            "Continuer avec la page d'authentification"
          );
        } else {
          showNotification(
            "Erreur",
            res.message,
            TYPE_NOTIFICATION.ERROR,
            () => {navigate('/login')},
            "Fermer"
          );
        }
      })
      .finally(() => {
        setloading(false);
      });
  };

  useEffect(() => {
    if (AuthService.isConnected()) {
      navigate("/");
    } else {
      handleCheckToken();
    }
  }, []);

  return (
    <>
      <NotificationComponent />
      <Toast />
      {/* <Grid item xs={12} lg={8} display={"flex"} flexDirection={"column"} m={3}>
        <Paper sx={{ p: 3 }}>
          <Grid item xs={12} display={"flex"} justifyContent="center">
            {FID_LOGO}
          </Grid>
          <CardHeader
            title="Activation de votre compte"
            subheader="Votre compte est activé avec succès, vous pouvez maintenant allez vers la page d'authentification pour vous connecter."
          />
          <Grid
            container
            display={"flex"}
            flexDirection={"column"}
            justifyContent="center"
            alignItems="center"
          >
            <Grid container display={"flex"} flexDirection={"column"}></Grid>
            <Grid
              item
              display={"flex"}
              justifyContent="center"
              alignItems="center"
              pt={5}
              width={"100%"}
            >
              <LoadingButton
                loading={loading}
                variant="outlined"
                type="submit"
                onClick={goToLogin}
              >
                Continuer avec la page d'authentificaiton
              </LoadingButton>
            </Grid>
          </Grid>
        </Paper>
      </Grid> */}
    </>
  );
};

export default CompteActivationPage;
